/**
 * 屏蔽电话号码中间四位（增强版）
 * @param {string} phone 原始电话号码
 * @param {object} options 配置选项
 * @param {string} [options.maskChar='*'] 屏蔽字符
 * @param {number} [options.maskLength=4] 屏蔽位数
 * @returns {string} 屏蔽后的电话号码
 */
export const maskPhoneNumber = function (phone, options = {}) {
  if (!phone || typeof phone !== 'string') return phone;

  const {
    maskChar = '*',
    maskLength = 4
  } = options;

  const mask = maskChar.repeat(maskLength);
  const cleaned = phone.replace(/\D/g, '');

  // 1. 手机号处理 (11位，1开头)
  if (/^1[3-9]\d{9}$/.test(cleaned)) {
    return phone.replace(/(\d{3})\d{4}(\d{4})/, `$1${mask}$2`);
  }

  // 2. 国内座机号处理（支持多种格式）
  if (/^(0\d{2,3})\d{7,8}$/.test(cleaned)) {
    // 处理带区号的座机 (如028-12345678)
    if (phone.includes('-')) {
      const parts = phone.split('-');
      if (parts.length === 2 && parts[1].length >= 4) {
        // 屏蔽号码部分的中间4位
        const numberPart = parts[1];
        const visiblePrefix = Math.max(0, Math.floor((numberPart.length - maskLength) / 2))
        const visibleSuffix = numberPart.length - maskLength - visiblePrefix
        const maskedNumber = numberPart.replace(
            new RegExp(`(\\d{${visiblePrefix}})\\d{${maskLength}}(\\d{${visibleSuffix}})`),
            `$1${mask}$2`
        );
        return `${parts[0]}-${maskedNumber}`;
      }
    }
    // 普通座机号处理
    return phone.replace(/(\d{3,4})\d{4}(\d{4})/, `$1${mask}$2`);
  }

  // 3. 国际号码处理（保留前3位和后3位）
  if (/^\d{7,}$/.test(cleaned)) {
    const visiblePrefix = Math.floor((cleaned.length - maskLength) / 2);
    const visibleSuffix = cleaned.length - maskLength - visiblePrefix;
    const regex = new RegExp(`(\\d{${visiblePrefix}})\\d{${maskLength}}(\\d{${visibleSuffix}})`);
    return phone.replace(regex, `$1${mask}$2`);
  }

  // 4. 保留原始格式但屏蔽中间部分（通用处理）
  const digitCount = (phone.match(/\d/g) || []).length;
  if (digitCount >= 7) {
    // 尝试保持原始分隔符
    let result = '';
    let digitIndex = 0;
    for (const char of phone) {
      if (/\d/.test(char)) {
        digitIndex++;
        // 只显示前几位和后几位，中间屏蔽
        const showChar = (digitIndex <= 3 || digitIndex > digitCount - 4)
            ? char
            : maskChar;
        result += showChar;
      } else {
        result += char; // 保留非数字字符
      }
    }
    return result;
  }

  return phone;
};
